import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"pix-background-header\" ...attributes>\n  <div class=\"pix-background-header__background\"></div>\n\n  <div class=\"pix-background-header__content\">\n    {{yield}}\n  </div>\n</div>", {
  moduleName: "@1024pix/pix-ui/components/pix-background-header.hbs"
});